import { useRestApiProvider } from "@jugl-web/rest-api";
import { useTranslations } from "@jugl-web/utils";
import React, { useMemo } from "react";
import { DataLoadingWrapper } from "@jugl-web/ui-kit";
import { CustomSection } from "./components/CustomSection";
import { IntegrationsSection } from "./components/IntegrationsSection";

export const AutomateTabContent: React.FC<{ entityId: string }> = ({
  entityId,
}) => {
  const { t } = useTranslations();
  const { integrationsApi } = useRestApiProvider();

  const {
    data: agentConfig,
    isLoading: isAgentConfigLoading,
    isError: isAgentConfigError,
    refetch: refetchAgentConfig,
  } = integrationsApi.useGetAiAgentConfigQuery({
    entityId,
    meta: { silent: true },
  });

  const customToolsCount = useMemo(
    () =>
      agentConfig?.config.tools?.find((tool) => tool.pack === "custom")
        ?.custom_template_data?.length ?? 0,
    [agentConfig]
  );

  return (
    <DataLoadingWrapper
      isLoading={isAgentConfigLoading}
      isError={isAgentConfigError}
      onRetry={refetchAgentConfig}
    >
      <div className="jugl__custom-scrollbar flex h-full flex-col overflow-y-auto">
        <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-10 p-12">
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <div className="flex items-center gap-2">
                <span className="font-secondary text-[22px] font-semibold text-[#1A2023]">
                  {t({
                    id: "cx-actions-page.custom",
                    defaultMessage: "Custom",
                  })}
                </span>
                <div className="flex h-[19px] items-center justify-center rounded-2xl border border-solid border-[#EEF2F5] bg-white px-2 font-secondary text-sm text-dark-700">
                  {customToolsCount}
                </div>
              </div>
              <span className="font-secondary text-sm text-[#737B7E]">
                {t({
                  id: "cx-actions-page.custom-description",
                  defaultMessage:
                    "Create custom Automations to power up the customers support",
                })}
              </span>
            </div>
            <CustomSection entityId={entityId} />
          </div>
          <div className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <span className="font-secondary text-[22px] font-semibold text-[#1A2023]">
                {t({
                  id: "cx-actions-page.integrated",
                  defaultMessage: "Integrated",
                })}
              </span>
              <span className="font-secondary text-sm text-dark-600">
                {t({
                  id: "cx-actions-page.integrated-description",
                  defaultMessage:
                    "Integrate with external apps to create smart Automations",
                })}
              </span>
            </div>
            <IntegrationsSection entityId={entityId} />
          </div>
        </div>
      </div>
    </DataLoadingWrapper>
  );
};
